import React, { useEffect, useState } from 'react'
import { Card, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import CambioGestion from './cambioGestion'
import Acciones from './acciones'
import GestionActual from './gestionActual'
import { useFormik } from 'formik'
import {configuracionFormAction13, obtenerComboCambiarAmbitoGestion, obtenerComboTipoGestion, PostCambiarGestion} from '../../store/actions/cambio-gestion-action'
import { validationSchemas } from '../../common/validation-Schemas-cambio-gestion'
import {LoadingComponent} from 'recupero-comunes'
const CambiarTipoGestion = ({handleClose}) => {  
  const [loading, setLoading]=useState(false)
  const [isHito, setIsHito]=useState(false)
  const data_cambiarGestion = useSelector((state) => state.cambiarGestionReducer)
  const { cfg_form13,comboCAmbitoGestion, comboHitos } = data_cambiarGestion
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const { llaves, datosGestion} = data_recepciona
  const [showToast, setShowToast] = useState(false);

    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true)
  const dispatch = useDispatch()
  useEffect(() => {
    if(llaves){
      setLoading(true)
      let query = Buffer.from(
        JSON.stringify({"rutcia":llaves && llaves["idOrgCaso"], idform: 13})
      ).toString('base64')
      dispatch(configuracionFormAction13(query))
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({concepto: 207})
        ).toString('base64')
        dispatch(obtenerComboTipoGestion(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({concepto: 232})
        ).toString('base64')
        dispatch(obtenerComboCambiarAmbitoGestion(query))
      }).then(()=>setLoading(false))
    }
  }, [dispatch,llaves])



  const formik = useFormik({
    initialValues: {
      "idCaso":"",
      "idImplicadoCaso":"",
      "idOrganizacion":"",
      "idCarpetaResExt":"",
      "codTipoGestionActual": "",
      "codTipoGestionNuevo": "",
      "codAmbitoGestionActual": "",
      "glosaAmbitoGestionActual": "",
      "codAmbitoGestionNuevo": "",
      "glosaAmbitoGestionNuevo": "",
      "codHitoCambioGestion": "",
      "glosaHitoCambioGestion": "",
      "fechaHitoCambioGestion": "",
      "minutaHitoCambioGestion": "",
      "aliasApp": "RECEPASICASO",
      "idUsuario":""
  

    },
    validationSchema: validationSchemas(isHito),
    onSubmit: (formData) => {    
      const dataForm = { ...formData }     
      dataForm["idCaso"]=llaves && llaves["idCaso"]
      dataForm["idImplicadoCaso"]=llaves && llaves["idImplicado"]
      dataForm["idOrganizacion"]=llaves && llaves["idOrgCaso"]
      dataForm["idUsuario"]=llaves && llaves["idUsuario"]
      const glozaAmbitoActual=datosGestion && datosGestion.datosGestion[0]["idCarpetaResExt"]
      dataForm["idCarpetaResExt"]=datosGestion && datosGestion.datosGestion[0]["idCarpetaResExt"]
      dataForm["codTipoGestionActual"]=datosGestion && datosGestion.datosGestion[0]["codTipoGestion"]
      dataForm["codAmbitoGestionActual"]=datosGestion && datosGestion.datosGestion[0]["codAmbitoGestion"]
      dataForm["glosaAmbitoGestionActual"]=comboCAmbitoGestion && comboCAmbitoGestion.comboCAmbitoGestion.find(c=>c.id===parseInt(datosGestion && datosGestion.datosGestion[0]["codAmbitoGestion"]))?.nombre
      dataForm["glosaAmbitoGestionNuevo"]=comboCAmbitoGestion && comboCAmbitoGestion.comboCAmbitoGestion.find(c=>c.id===parseInt(dataForm["codAmbitoGestionNuevo"]))?.nombre
      dataForm["glosaHitoCambioGestion"]=comboHitos && comboHitos.comboHitos.find(c=>c.id===parseInt(dataForm["codHitoCambioGestion"]))?.nombre
     
      dispatch(PostCambiarGestion(dataForm))
      handleShowToast()
    }
  })
  return (
    <div> 
      <LoadingComponent show={loading}/>
    <Card >
      <Card.Header as='h6'  style={{backgroundColor:"#4F517A", color:"white"}} >{cfg_form13 && cfg_form13.cfg_form13["cambiotipogestion-title-page"]}</Card.Header>
      <Card.Body>
      <Form onSubmit={formik.handleSubmit}>
          <GestionActual formik={formik}/>
          <CambioGestion formik={formik} setIsHito={setIsHito} 
          isHito={isHito}
          setShowToast={setShowToast}
          showToast={showToast}
          />
          <Acciones handleClose={handleClose}/>
      </Form>
        </Card.Body>
      </Card>
    </div>
  )
}

export default CambiarTipoGestion